
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/despre-noi",
      function () {
        return require("private-next-pages/despre-noi.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/despre-noi"])
      });
    }
  